import { signOut } from '../api';
import { centralLoginUrl } from './surface-links';
import { runSignOut } from './sign-out-progress';

// Sign out from any piece of chrome (rail, account menu, More sheet): end the shared
// session server-side (POST /auth/logout clears the HttpOnly refresh cookie, AP-D4),
// drop the in-memory access token, then bounce to the central website sign-in — the
// same deterministic SSO bounce the auth gate uses (DR-35). One named file so the
// entry points cannot drift apart. sign-out-progress.tsx makes it run once (a second
// click is ignored), disables every sign-out control and shows the "Signing out…"
// veil until the browser leaves — on failure too (the local token is already gone).
export async function signOutAndBounce(): Promise<void> {
  await runSignOut(signOut, () => {
    window.location.href = centralLoginUrl();
  });
}
